import React from "react";
import { DeviceThermostat } from "@mui/icons-material";
import { convertToFormattedUnit } from "../../common/number-unit-helper";

/**
 * Get icon for temperature widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getTemperatureIcon = (widget = null) => {
  const iconProps = {
    style: { fontSize: "1.5rem", paddingBottom: "2px" },
  };

  return <DeviceThermostat {...iconProps} />;
};

export const getTemperatureSubtitle = (widget = null) => {
  if (!widget) return "";

  const temp = widget?.items?.$w1?.value;
  const unit = widget?.items?.$w1?.unit || "C";

  if (temp !== undefined && temp !== null) {
    return convertToFormattedUnit(temp, unit, 1) || "";
  }

  return "";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getTemperaturePatterns = () => {
  return ["basic.device.temperature"];
};
